module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"toUpgradePlan":"Повысить тариф","multiuser-na":"Многопользовательский режим недоступен на вашем тарифе"}}')
  delete Component.options._Ctor
}
